// src/components/RichHtmlEditor.jsx
import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import 'tinymce/tinymce';
import 'tinymce/models/dom';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/wordcount';
import 'tinymce/skins/ui/oxide/skin.css';
import 'tinymce/skins/content/default/content.css';
import { buildEmailEditorConfig } from '../constants/emailEditorConfig';

// The one rich-text editor used everywhere email HTML gets authored
// (signature templates, legal disclaimers, banner campaigns) — same
// plugins/toolbar/fonts everywhere, so admins get a consistent authoring
// experience regardless of which of the three they're editing.
export default function RichHtmlEditor({ initialValue, onEditorChange, onInit, height = 360, brandColors }) {
  return (
    <Editor
      onInit={onInit}
      initialValue={typeof initialValue === 'string' ? initialValue : ''}
      onEditorChange={onEditorChange}
      init={buildEmailEditorConfig({ height, brandColors })}
    />
  );
}
